// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';

// State
import { GConfigState } from '../_reducers/gconfig.reducers';

export const selectGConfigState =
  createFeatureSelector<GConfigState>('gconfig');

export const selectGConfigById = (ident: string) =>
  createSelector(
    selectGConfigState,
    gconfigState => gconfigState.entities[ident]
  );
